export default "__VITE_ASSET__DPPjwLdO__"